<template>
  <b-navbar class="bgGreen" toggleable="md" type="light" >

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <b-navbar-brand style="color:white" href="#">sinavanaliz.ankaradil.com</b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">

      <b-navbar-nav>
        <router-link class="nav-link" to="/">Ana Sayfa</router-link>
<!--        <router-link class="nav-link" to="/uyeol" v-show="!loggedin">Üye Ol</router-link>-->
<!--        <router-link class="nav-link" to="/login" v-show="!loggedin">Giriş Yap</router-link>-->
        <router-link class="nav-link" to="/sinavlarim" v-show="loggedin">Sınavlarım</router-link>
<!--        <router-link class="nav-link" to="/satinal">Satın Al</router-link>-->
        <router-link class="nav-link" to="/eyds-hazirlik-kamp-programlari">E-YDS Hazırlık Kamp Programları</router-link>
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right v-show="loggedin">
          <template slot="button-content">
            <em>{{user.email}}</em>
          </template>
          <b-dropdown-item href="#">Profil</b-dropdown-item>
          <b-dropdown-item href="#" @click="logoutbtn">Çıkış</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Navbar',
  methods: {
    ...mapActions([
      'logout_ACTION'
    ]),
    logoutbtn: function (e) {
      e.preventDefault()
      this.logout_ACTION()
      this.$router.push('/')
    }
  },
  computed: {
    ...mapState([
      'loggedin',
      'user'
    ])
  }
  // data: () => {
  //   return {
  //     User: this.user
  //   }
  // }
}
</script>

<style scoped>
.bgGreen{
  background-color:#4a7185;
}
.navbar-light .navbar-nav .nav-link{
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue